import { useEffect } from 'react';

/**
 * Onboarding raster URLs resolved at build time by Vite's glob.
 * Paths are project-root-absolute (`@` is not supported inside glob patterns).
 */
const ONBOARDING_IMAGE_URLS = Object.values({
  ...import.meta.glob('/src/features/onboarding/assets/**/*.{webp,png,jpg}', {
    eager: true,
    query: '?url',
    import: 'default',
  }),
  ...import.meta.glob('/src/assets/brand-logos/**/*.{webp,png,jpg}', {
    eager: true,
    query: '?url',
    import: 'default',
  }),
}) as string[];

/** Keep Image handles alive so in-flight downloads aren't GC'd mid-warm. */
let warmedImages: HTMLImageElement[] | null = null;

/**
 * Warm onboarding step / logo images into the browser cache on first mount,
 * so later steps don't flash-load their assets on entry.
 */
export function usePreloadOnboardingImages() {
  useEffect(() => {
    if (warmedImages) return;
    warmedImages = ONBOARDING_IMAGE_URLS.map((src) => {
      const img = new Image();
      img.src = src;
      return img;
    });
  }, []);
}
